/**
 * Accordion partial.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @copyright 2024 Simon Lagerlöf
 * @since 1.0.0
 */

export default function partialAccordion() {
  const accordions = document.querySelectorAll('details.accordion');

  accordions.forEach((accordion) => {
    const summary = accordion.querySelector(
      'summary.accordion__summary',
    );

    const content = accordion.querySelector('.accordion__content');
    const chevron = accordion.querySelector('.accordion__chevron');

    if (
      !(accordion instanceof HTMLDetailsElement) ||
      !(summary instanceof HTMLElement) ||
      !(content instanceof HTMLElement) ||
      !(chevron instanceof SVGElement)
    ) {
      return;
    }

    const timeout =
      parseFloat(
        window.getComputedStyle(accordion).transitionDuration,
      ) * 1000;

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (!accordion.open) {
        accordion.style.height = `${summary.offsetHeight}px`;
        accordion.open = true;

        const contentHeight = content.offsetHeight + 16;

        content.style.height = '0px';

        accordion.style.height = `${summary.offsetHeight + contentHeight}px`;

        content.style.height = `${contentHeight}px`;

        chevron.style.transform = 'rotate(180deg)';
      } else {
        (async () => {
          accordion.style.height = `${summary.offsetHeight}px`;

          content.style.height = `0px`;

          chevron.style.transform = 'rotate(0deg)';

          await new Promise((resolve) =>
            setTimeout(resolve, timeout),
          );

          accordion.open = false;

          content.style.height = '';

          accordion.style.height = '';
        })();
      }
    });
  });
}
